<template>
  <div class="flex items-center">
    <DOverlayBadge severity="danger">
      <DButton
        rounded
        class="hover:border-primary! hover:text-primary h-7 w-7 border border-gray-600 bg-gray-900 p-1 text-gray-300"
        ><Star />
      </DButton>
    </DOverlayBadge>
    <div class="ml-4">What's New</div>
  </div>
</template>

<script setup>
import { DButton, DOverlayBadge } from '@disguise/cloud-ui';
import { Star } from '@disguise/cloud-ui/icons';
</script>
